import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonsModule } from '@progress/kendo-angular-buttons';

import { ModalModule } from '@app/shared/dialogs/modal/modal.module';
import { SimpleComponentsModule } from '@app/shared/ui/simple-components/simple-components.module';
import { TypifiedModalComponent } from '@app/shared/dialogs/typified-modal/typified-modal.component';

@NgModule({
  declarations: [TypifiedModalComponent],
  imports: [CommonModule, ModalModule, SimpleComponentsModule, ButtonsModule],
  exports: [TypifiedModalComponent],
})
export class TypifiedModalModule {}
